import { render, staticRenderFns } from "./AddContract.vue?vue&type=template&id=3d0385c6"
import script from "./AddContract.vue?vue&type=script&lang=js"
export * from "./AddContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports